import React from "react";
import { Box, Typography } from "@mui/material";

const StudyCodeLabelHelper = ({ label, value }) => (
  <Box sx={{ textAlign: { xs: "left", sm: "right" } }}>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ display: "block", lineHeight: 1.2 }}>
      {label}
    </Typography>
    <Typography sx={{ color: "primary.main", fontWeight: 700 }}>
      {value || "-"}
    </Typography>
  </Box>
);

export default StudyCodeLabelHelper;
